import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, DatePicker, message, Space, Button } from "antd";
import axios from "axios";
import moment from "moment/moment";
import localhost from "../../constants/localhost";

export default ({ id }) => {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [detail, setDetail] = useState({});

  useEffect(() => {
    if (!open) {
      return;
    }
    axios
      .get(`${localhost}/manage/distributionManage/getDetail?id=${id}`)
      .then(() => {
        setDetail();
      });
  }, [open]);

  const onSubmit = () => {
    form.validateFields((vals) => {
      const formData = vals;
      if (formData.releaseDate) {
        formData.releaseDateStart = moment(formData.releaseDate[0]).format(
          "YYYY-MM-DD"
        );
        formData.releaseDateEnd = moment(formData.releaseDate[1]).format(
          "YYYY-MM-DD"
        );
        formData.releaseDate = undefined;
      }
      axios
        .post(`${localhost}/manage/distributionManage/save`, formData)
        .then((res) => {
          message.success("编辑成功");
        })
        .catch((error) => {
          message.error("网络异常，请重试！");
        });
    });
  };

  return (
    <>
      <a onClick={() => setOpen(true)}>编辑</a>
      <Drawer
        title="编辑"
        width={500}
        destroyOnHidden
        open={open}
        onClose={() => setOpen(false)}
        extra={
          <Space>
            <Button onClick={() => setOpen(false)}>关闭</Button>
            <Button type="primary" onClick={onSubmit}>
              提交
            </Button>
          </Space>
        }
      >
        <Form labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} form={form}>
          <Form.Item label="作品名称" name="name" required>
            <Input placeholder="请输入作品名称" />
          </Form.Item>
          <Form.Item label="浏览量(PV)" name="pv">
            <Input />
          </Form.Item>
          <Form.Item label="浏览量(UV)" name="uv">
            <Input />
          </Form.Item>
          <Form.Item label="状态" name="status">
            <Input />
          </Form.Item>
          <Form.Item label="排名" name="ranking">
            <Input />
          </Form.Item>
          <Form.Item label="‌评分" name="score">
            <Input />
          </Form.Item>
          <Form.Item label="下载量" name="downloadCount">
            <Input />
          </Form.Item>
          <Form.Item label="转发量" name="repostCount">
            <Input />
          </Form.Item>
          <Form.Item label="引用次数" name="referenceCount">
            <Input />
          </Form.Item>
          <Form.Item label="作者" name="author">
            <Input />
          </Form.Item>
          <Form.Item label="发布时间" name="releaseDate">
            <DatePicker />
          </Form.Item>
          <Form.Item label="更新时间‌" name="modifyDate">
            <DatePicker />
          </Form.Item>
          <Form.Item label="结束时间" name="endDate">
            <DatePicker />
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};
